import { CoordinateExtent } from '@xyflow/react';
import { TDatabase } from '../../types/types';

export const getQueryStructure = (vendor: TDatabase) => {
  let query = '';
  switch (vendor) {
    case 'postgresql':
      query = '-- SELECT * FROM database_name.schema_name.table_name ';
      break;
    case 'mysql':
      query = '-- SELECT * FROM database_name.table_name';
      break;
    case 'sqlserver':
      query = '-- SELECT * FROM database_name.schema_name.table_name';
      break;
    case 'oracle':
      query = '-- SELECT * FROM schema_name.table_name';
      break;
    case 'db2':
      query = '-- SELECT * FROM schema_name.table_name';
      break;
    case 'mariadb':
      query = '-- SELECT * FROM schema_name.table_name';
      break;
    // case 'mariadb':
    //   query = '-- SELECT * FROM database_name.table_name';
    //   break;
    case 'teradata':
      query = '-- SELECT * FROM database_name.table_name';
      break;
    case 'snowflake':
      query = '-- SELECT * FROM database_name.schema_name.table_name';
      break;
    case 'bigquery':
      query = '-- SELECT * FROM `project_id.dataset.table`';
      break;
    case 'redshift':
      query = '-- SELECT * FROM database_name.schema_name.table_name';
      break;
    case 'amazonathena':
      query = '-- SELECT * FROM database_name.table_name';
      break;
    case 'databricks':
      query = '-- SELECT * FROM catalog_name.schema_name.table_name';
      break;
    case 'motherduck':
      query = '-- SELECT * FROM database_name.schema_name.table_name';
      break;
    case 'saphana':
      query = '-- SELECT * FROM schema_name.table_name';
      break;
    case 'clickhouse':
      query = '-- SELECT * FROM database_name.table_name';
      break;
    default:
      query = ' ';
  }
  return query;
};

export const calculateNewNodePosition = (idx: number): { x: number; y: number } => {
  const nodeBounds: CoordinateExtent = [
    [-1900, -1000],
    [1950, 1110],
  ];
  const MARGIN = 500;

  const minX = nodeBounds[0][0] + MARGIN + 50;
  const maxX = nodeBounds[1][0] - MARGIN - 250; // node width + safety
  const minY = nodeBounds[0][1] + MARGIN + 50;
  const maxY = nodeBounds[1][1] - MARGIN - 150;

  const NODE_WIDTH = 210;
  const GAP_X = 20; 
  const ROW_HEIGHT = 400; // can fit dynamic height node

  const usableWidth = maxX - minX;

  // number of columns we can fit
  const maxCols = Math.max(1, Math.floor(usableWidth / (NODE_WIDTH + GAP_X)));

  const col = idx % maxCols;
  const row = Math.floor(idx / maxCols);

  let x = minX + col * (NODE_WIDTH + GAP_X);
  let y = minY + row * ROW_HEIGHT;

  // ensure inside boundaries
  x = Math.max(minX, Math.min(x, maxX));
  y = Math.max(minY, Math.min(y, maxY));

  return { x, y };
};


export const reverseCardinality = (cardinality: string) => {
    const lower = cardinality.toLowerCase();

    if (lower === "one to many") return "many to one";
    if (lower === "many to one") return "one to many";

    return cardinality;
  }; 

export const reverseIntegrity = (integrity: string): string => {
    const lower = integrity.toLowerCase();

    if (lower === 'left') return 'right';
    if (lower === 'right') return 'left';

    return integrity;
  };